// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n.trigger-the-setting .bordered-div[data-v-64831034] {\n  border: 2px solid #000;\n  /* 2像素宽的黑色实线边框 */\n  padding: 10px;\n  /* 可选：添加内边距以使内容不紧贴边框 */\n  height: 34px;\n  text-align: center;\n}\n.trigger-the-setting .no-edit[data-v-64831034] {\n  pointer-events: none;\n}\n", ""]);
// Exports
module.exports = exports;
